// import "@babel/polyfill";
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import VueRouter from "vue-router";
import VueAgile from "vue-agile";
import VModal from "vue-js-modal";
import App from "./App.vue";
import routes from "./routes";
import data from "./data.js";
import Header from "./components/Header.vue";

Vue.component("Header", Header);
Vue.config.productionTip = false;

Vue.mixin({
    data: function() {
        return {
            projectList: data
        };
    }
});

Vue.use(VModal, { dialog: true });
Vue.use(VueRouter, VueAgile);

const router = new VueRouter({
    mode: "history",
    // base: process.env.BASE_URL,
    routes
});

new Vue({
    el: "#app",
    router,
    render: h => h(App)
});
